const BRANDS = [
  { prefix: "openai/gpt-", brand: "ChatGPT", strip: /^OpenAI:\s*/, skip: /gpt-oss/ },
  { prefix: "anthropic/claude", brand: "Claude", strip: /^Anthropic:\s*Claude\s*/ },
  { prefix: "google/gemini", brand: "Gemini", strip: /^Google:\s*Gemini\s*/ },
];

const brandOf = m => BRANDS.find(b => m.id.startsWith(b.prefix) && !(b.skip && b.skip.test(m.id)));

export const directorLabel = m => {
  const b = brandOf(m);
  const name = b ? `${b.brand} (${(m.name || m.id).replace(b.strip, "")})` : m.name || m.id;
  return m.cost_tier ? `${name} · ${m.cost_tier}` : name;
};

// Main list: the newest few ChatGPT, Claude and Gemini models; everything else under "More models".
export const DirectorSelect = ({ models = [], value, onChange, perBrand = 4 }) => {
  const main = BRANDS.flatMap(b => models.filter(m => brandOf(m) === b).sort((x, y) => (y.created || 0) - (x.created || 0)).slice(0, perBrand));
  const mainIds = new Set(main.map(m => m.id));
  const more = models.filter(m => !mainIds.has(m.id));
  const known = value === "recommended" || models.some(m => m.id === value);
  return (
    <select value={value || "recommended"} onChange={e => onChange(e.target.value)} data-testid="director-model-select">
      <option value="recommended">Recommended · strongest writer (Claude Opus first)</option>
      {!known && value && <option value={value}>{value} · unavailable</option>}
      <optgroup label="ChatGPT · Claude · Gemini">
        {main.map(m => <option key={m.id} value={m.id}>{directorLabel(m)}</option>)}
      </optgroup>
      {more.length > 0 && <optgroup label="More models">
        {more.map(m => <option key={m.id} value={m.id}>{directorLabel(m)}</option>)}
      </optgroup>}
    </select>
  );
};
